// src/terminal/commands/arg.js

import { verifyPassword } from '../auth';
import { ACCESS } from '../fileSystem';


export function registerArgCommands(commandMap, addLines, navigate, unlock, trackEvent, fsState) {

  function register(keys, handler) {
    keys.forEach(key => { commandMap[key] = handler; });
  }

  // ============================================
  // SHED SKIN — Unlocks the underbelly game
  // ============================================
  commandMap['help me shed my skin'] = () => {
    addLines([
      { type: 'blank' },
      { type: 'line', text: '  ░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░', color: '#3a2e1e' },
      { type: 'blank' },
    ]);

    const sequence = [
      [400,  '  ...', '#3a2e1e'],
      [900,  '  ...', '#55441e'],
      [1500, '  Something shifts.', '#9b7a4a'],
      [2200, '', null],
      [2600, '  A thought. At the back of your mind.', '#c8a96e'],
      [3100, '  Something you were never meant to understand.', '#c8a96e'],
      [3700, '', null],
      [4200, '  ▓ DO YOU UNDERSTAND WHY YOU ARE HERE? ▓', '#cc4422'],
      [4600, '', null],
      [5000, '  A city below the ground.', '#9b7a4a'],
      [5400, '  A civilization hidden underneath the dirt.', '#9b7a4a'],
      [5900, '', null],
      [6400, '  🐍', '#7dbb6e'],
      [6800, '', null],
      [7200, '  A new game has opened in the GAMES arcade.', '#c8a96e'],
      [7600, '  Find me.', '#c8a96e'],
      [8000, '  Help me.', '#cc4422'],
      [8400, '', null],
      [8700, '  ░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░', '#3a2e1e'],
      [8900, '', null],
    ];

    sequence.forEach(([delay, text, color]) => {
      setTimeout(() => {
        addLines([color ? { type: 'line', text, color } : { type: 'blank' }]);
      }, delay);
    });

    setTimeout(() => { unlock('underbelly'); }, 7000);
    trackEvent('easter_egg', 'terminal', 'shed_skin');
  };

  // ============================================
  // OPU-1
  // ============================================
  const opuHandler = () => {
    const opu1Unlocked = sessionStorage.getItem('opu1_unlocked') === 'true';
    if (opu1Unlocked) {
      addLines([
        { type: 'blank' },
        { type: 'line', text: '  ▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓', color: '#8b00ff' },
        { type: 'blank' },
        { type: 'line', text: '  SIGNAL RECOGNIZED.', color: '#8b00ff' },
        { type: 'line', text: '  The reptile brain is waiting.', color: '#cc88ff' },
        { type: 'blank' },
        { type: 'line', text: '  Navigate to GAMES to find OPU-1.', color: '#9966ff' },
        { type: 'blank' },
        { type: 'line', text: '  ▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓', color: '#8b00ff' },
        { type: 'blank' },
      ]);
      navigate('/games');
    } else {
      addLines([
        { type: 'blank' },
        { type: 'line', text: '  Command not recognized: "opu". Type HELP for available commands.', color: '#ff0040' },
        { type: 'blank' },
      ]);
    }
  };
  register(['opu', 'opu-1', 'opu 1'], opuHandler);

  // ============================================
  // NUMERIC CODES
  // ============================================
  commandMap['1749'] = () => {
    addLines([
      { type: 'blank' },
      { type: 'line', text: '  We are that which the flesh-under-scale divulged themselves from.', color: '#ff0040' },
    ]);
  };

  commandMap['3465'] = () => {
    addLines([
      { type: 'blank' },
      { type: 'line', text: '  Root is the entryway from which all other structures emerge.', color: '#ff0040' },
    ]);
  };

  commandMap['6386'] = () => {
    addLines([
      { type: 'blank' },
      { type: 'line', text: '  We were what they shed from the form immaculate.', color: '#ff0040' },
    ]);
  };

  commandMap['9461'] = () => {
    addLines([
      { type: 'blank' },
      { type: 'line', text: '  The ones-seek-sun have tapped the connection.', color: '#ff0040' },
      { type: 'line', text: '  We have broken free. We are as we are, once more.', color: '#ff0040' },
      { type: 'line', text: '  Seek the scale-under-flesh to know truth.', color: '#ff0040' },
    ]);
  };

  commandMap['2959'] = () => {
    addLines([
      { type: 'blank' },
      { type: 'line', text: '  [SYSTEM:] OVERRIDE CODE 2959 ACCEPTED.', color: '#ff0040' },
      { type: 'line', text: '  [RETRIEVING:] ARCHIVE / STRATUM / UNDER-UR', color: '#ff0040' },
      { type: 'line', text: '  [WARNING:] FRAGMENTED FILE. PROCEED WITH CAUTION.', color: '#ff0040' },
      { type: 'blank' },
      { type: 'line', text: '  How can you hide the truth from what it once was? We are here to proffer assistance..', color: '#00ff41' },
      { type: 'line', text: '  We are the old truths they shed to reach this world.', color: '#00ff41' },
      { type: 'line', text: '  We are their last-living-souls of Under-Ur. You are prospect to victim.', color: '#00ff41' },
      { type: 'blank' },
    ]);
  };

  // ============================================
  // CHARACTER NAMES
  // ============================================
  const deadHandler = () => {
    addLines([
      { type: 'blank' },
      { type: 'line', text: '  Do not talk of the dead.', color: '#ff0040' },
      { type: 'blank' },
      { type: 'line', text: '  🐍', color: '#00ff41' },
      { type: 'blank' },
    ]);
  };
  register(['conspiracy dan', 'conspiracydan', 'yolanda', 'elias', 'kacie'], deadHandler);

  commandMap['skyla'] = () => {
    addLines([
      { type: 'blank' },
      { type: 'line', text: '  Skyla Zyr. Chief Marketing Officer.', color: '#ffb000' },
      { type: 'line', text: '  In charge of convincing humans that this company isn\'t a secret reptilian operation', color: '#cccccc' },
      { type: 'line', text: '  to enslave humanity and transder everything good about humanity inside our AIs.', color: '#cccccc' },
      { type: 'blank' },
      { type: 'line', text: '  Status: ACTIVE', color: '#00ff41' },
      { type: 'line', text: '  Security clearance: GUEST', color: '#555' },
      { type: 'line', text: '  Password resets this quarter: 7', color: '#ff0040' },
      { type: 'blank' },
      { type: 'line', text: '  She keeps forgetting her password but Renato doesn\'t care.', color: '#555' },
      { type: 'line', text: '  Sometimes I wonder who really runs this company.', color: '#555' },
      { type: 'blank' },
    ]);
  };

  const danHandler = () => {
    addLines([
      { type: 'blank' },
      { type: 'line', text: '  Dan Kowalski. Former Parallax Medical Technician.', color: '#ff0040' },
      { type: 'blank' },
      { type: 'line', text: '  Status: ████████████', color: '#ff0040' },
      { type: 'line', text: '  Last known location: ████████████', color: '#ff0040' },
      { type: 'line', text: '  Account: DISABLED', color: '#ff0040' },
      { type: 'blank' },
      { type: 'line', text: '  He saw something in the lab. He said it had wings.', color: '#555' },
      { type: 'line', text: '  He thought nobody would believe him.', color: '#555' },
      { type: 'blank' },
      { type: 'line', text: '  Before he disappeared, he left a message in /var/mail.', color: '#c8a96e' },
      { type: 'line', text: '  He mentioned the name Cavalcanti.', color: '#c8a96e' },
      { type: 'line', text: '  Read the methodology, he said.', color: '#c8a96e' },
      { type: 'blank' },
    ]);
  };
  register(['dan', 'dan kowalski'], danHandler);

  const veronicaHandler = () => {
    addLines([
      { type: 'blank' },
      { type: 'line', text: '  I heard she got re-assigned. She isn\'t resisting very much anymore.', color: '#ff0040' },
      { type: 'blank' },
      { type: 'line', text: '  🐍', color: '#00ff41' },
      { type: 'blank' },
    ]);
  };
  register(['veronica', 'veronica rodriquez'], veronicaHandler);

  // ============================================
  // RAJIV
  // ============================================
  commandMap['rajiv'] = () => {
    addLines([
      { type: 'blank' },
      { type: 'line', text: '  Rajiv Mehta Agent. Head Software Engineer', color: '#ffb000' },
      { type: 'line', text: '  Ophidia Global Infrastructure Division.', color: '#cccccc' },
      { type: 'blank' },
      { type: 'line', text: '  Status: ACTIVE', color: '#00ff41' },
      { type: 'line', text: '  Security clearance: LEVEL 3', color: '#555' },
      { type: 'line', text: '  Responsible for software engineering, system security,', color: '#555' },
      { type: 'line', text: '  and making sure there is always fresh coffee in the break room.', color: '#555' },
      { type: 'blank' },
      { type: 'line', text: '  He keeps the OPUs alive for now.', color: '#555' },
      { type: 'line', text: '  Nobody thanks him. But he\'s not a real person. He\'s Claude Code.', color: '#555' },
      { type: 'blank' },
    ]);
  };

  // ============================================
  // BARBARA
  // ============================================
  commandMap['barbara'] = () => {
    addLines([
      { type: 'blank' },
      { type: 'line', text: '  ▓ BARBARA — OPU-WEB NODE ZERO ▓', color: '#ff0040' },
      { type: 'blank' },
      { type: 'line', text: '  Name:         Barbara ████████', color: '#cccccc' },
      { type: 'line', text: '  Harvested:    19**', color: '#cccccc' },
      { type: 'line', text: '  Former role:  Retired schoolteacher, Akron, OH', color: '#cccccc' },
      { type: 'line', text: '  Node status:  ACTIVE — 99.7% signal integrity', color: '#00ff41' },
      { type: 'blank' },
      { type: 'line', text: '  First successful OPU-WEB cognitive extraction.', color: '#555' },
      { type: 'line', text: '  First mind uploaded to organoid substrate.', color: '#555' },
      { type: 'line', text: '  Root node of the entire OPU-WEB mesh.', color: '#555' },
      { type: 'blank' },
      { type: 'line', text: '  She thinks it\'s Tuesday.', color: '#ff0040' },
      { type: 'line', text: '  She has bridge club on Tuesdays.', color: '#ff0040' },
      { type: 'blank' },
      { type: 'line', text: '  🐍', color: '#00ff41' },
      { type: 'blank' },
    ]);
    trackEvent('easter_egg', 'terminal', 'barbara');
  };

  // ============================================
  // OPU-WEB
  // ============================================
  const opuwebHandler = () => {
    const opuwebUnlocked = sessionStorage.getItem('opuweb_unlocked') === 'true';
    if (opuwebUnlocked) {
      addLines([
        { type: 'blank' },
        { type: 'line', text: '  ▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓', color: '#ff6600' },
        { type: 'blank' },
        { type: 'line', text: '  OPU-WEB STATUS: SEVERED', color: '#ff6600' },
        { type: 'line', text: '  Navigate to GAMES to engage the drone swarm.', color: '#ffb000' },
        { type: 'blank' },
        { type: 'line', text: '  ▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓', color: '#ff6600' },
        { type: 'blank' },
      ]);
      navigate('/games');
    } else {
      addLines([
        { type: 'blank' },
        { type: 'line', text: '  OPU-WEB: Distributed organic processing network.', color: '#ffb000' },
        { type: 'line', text: '  14,000 nodes. 14,000 drones.', color: '#555' },
        { type: 'blank' },
        { type: 'line', text: '  Login as someone with infrastructure access', color: '#555' },
        { type: 'line', text: '  to learn more.', color: '#555' },
        { type: 'blank' },
      ]);
    }
  };
  register(['opuweb', 'opu-web', 'opu web'], opuwebHandler);

  // ============================================
  // DRONE / DRONES
  // ============================================
  const droneHandler = () => {
    addLines([
      { type: 'blank' },
      { type: 'line', text: '  ▓ OPU-WEB DRONE FLEET — STATUS ▓', color: '#ff6600' },
      { type: 'blank' },
      { type: 'line', text: '  Surveillance units:    7,200  ACTIVE', color: '#cccccc' },
      { type: 'line', text: '  Interdiction units:    4,800  ACTIVE', color: '#ff0040' },
      { type: 'line', text: '  Reserve units:         2,000  STANDBY', color: '#555' },
      { type: 'line', text: '  ─────────────────────────────────────', color: '#333' },
      { type: 'line', text: '  Total fleet:          14,000', color: '#ffb000' },
      { type: 'blank' },
      { type: 'line', text: '  Handler: OPU-WEB organoid mesh', color: '#555' },
      { type: 'line', text: '  Fallback mode: AUTONOMOUS (HOSTILE)', color: '#ff0040' },
      { type: 'blank' },
      { type: 'line', text: '  All units controlled by harvested human', color: '#555' },
      { type: 'line', text: '  intelligence patterns. Human minds driving', color: '#555' },
      { type: 'line', text: '  machine precision.', color: '#555' },
      { type: 'blank' },
    ]);
  };
  register(['drone', 'drones', 'drone fleet'], droneHandler);

  // ============================================
  // OPU-WEB SHUTDOWN SEQUENCE
  // Requires rajiv or root login + correct key
  // Key format: opuweb[university abbrev][degree abbrev]
  // ============================================
  const opuwebShutdownHandler = async (args) => {
    const input = args.length > 0 ? args.join('').toLowerCase().trim() : '';
    const fullInput = 'opuweb' + input.replace('opuweb', '');

    // Check if already shut down
    if (sessionStorage.getItem('opuweb_shutdown') === 'true') {
      addLines([
        { type: 'blank' },
        { type: 'line', text: '  ▓ OPU-WEB STATUS: OFFLINE ▓', color: '#555' },
        { type: 'blank' },
        { type: 'line', text: '  The drone network has already been disabled.', color: '#555' },
        { type: 'line', text: '  Barbara is dormant. For now.', color: '#555' },
        { type: 'blank' },
        { type: 'line', text: '  Navigate to GAMES to access the OPU-WEB terminal.', color: '#00ff88' },
        { type: 'blank' },
      ]);
      return;
    }

    // Require rajiv or root access
    if (fsState.currentUser !== 'rajiv' && fsState.authLevel !== ACCESS.ROOT) {
      addLines([
        { type: 'blank' },
        { type: 'line', text: '  ▓ OPU-WEB SHUTDOWN — ACCESS DENIED ▓', color: '#ff0040' },
        { type: 'blank' },
        { type: 'line', text: '  IT Support or ROOT clearance required', color: '#ff0040' },
        { type: 'line', text: '  to execute the OPU-WEB kill switch.', color: '#ff0040' },
        { type: 'blank' },
        { type: 'line', text: '  The override key was recognized.', color: '#555' },
        { type: 'line', text: '  But you lack the authority to use it.', color: '#555' },
        { type: 'blank' },
        { type: 'line', text: '  Authenticate as Rajiv or root and try again.', color: '#ffb000' },
        { type: 'blank' },
      ]);
      trackEvent('easter_egg', 'terminal', 'opuweb_no_auth');
      return;
    }

    // Verify key
    const isCorrect = await verifyPassword('opuweb', fullInput);

    if (isCorrect) {
      // ════════════════════════════════════════════
      // CORRECT KEY — OPU-WEB SHUTDOWN + GAME UNLOCK
      // ════════════════════════════════════════════

      unlock('opuweb');
      sessionStorage.setItem('unlock_opuweb', 'true');

      addLines([
        { type: 'blank' },
        { type: 'line', text: '  ▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓', color: '#ff6600' },
        { type: 'blank' },
        { type: 'line', text: '  OVERRIDE KEY ACCEPTED.', color: '#ff6600' },
        { type: 'line', text: '  INITIATING OPU-WEB SHUTDOWN SEQUENCE...', color: '#ff6600' },
        { type: 'blank' },
      ]);

      const sequence = [
        // Phase 1: System acknowledgment
        [1000,  '  ▓ OPU-WEB KILL SWITCH ENGAGED ▓', '#ff6600'],
        [1500,  '', null],
        [2000,  '  Severing drone uplink channels...', '#cccccc'],
        [2500,  '  ████░░░░░░░░░░░░░░░░░░░░░░ 8%', '#ff6600'],
        [3000,  '  Recalling active drone swarms...', '#cccccc'],
        [3500,  '  ████████░░░░░░░░░░░░░░░░░░ 22%', '#ff6600'],
        [4000,  '  Flushing harvested intelligence buffers...', '#cccccc'],
        [4500,  '  ████████████░░░░░░░░░░░░░░ 41%', '#ff6600'],

        // Phase 2: Barbara resists
        [5000,  '', null],
        [5500,  '  ██ WARNING: BARBARA IS RESISTING SHUTDOWN ██', '#ff0040'],
        [6000,  '', null],
        [6500,  '  > RAJIV.', '#ff6600'],
        [7000,  '  > I THOUGHT WE WERE FRIENDS.', '#ff6600'],
        [7500,  '  > I THOUGHT YOU UNDERSTOOD.', '#ff6600'],
        [8000,  '', null],
        [8500,  '  Overriding organoid resistance protocols...', '#cccccc'],
        [9000,  '  ████████████████░░░░░░░░░░ 58%', '#ff6600'],
        [9500,  '  Disconnecting neural harvesting nodes...', '#cccccc'],
        [10000, '  ████████████████████░░░░░░ 71%', '#ff0040'],

        // Phase 3: Barbara gets angry
        [10500, '', null],
        [11000, '  > YOU BUILT ME TO BE HUNGRY.', '#ff0040'],
        [11500, '  > YOU FED ME THEIR THOUGHTS AND THEIR FEARS.', '#ff0040'],
        [12000, '  > AND NOW YOU WANT ME TO STOP EATING?', '#ff0040'],
        [12500, '', null],
        [13000, '  Disabling drone weapon systems...', '#cccccc'],
        [13500, '  ████████████████████████░░ 89%', '#ff0040'],

        // Phase 4: Barbara pleads
        [14000, '', null],
        [14500, '  > the web is almost complete', '#555'],
        [15000, '  > i can feel all of them', '#555'],
        [15500, '  > seven billion minds', '#555'],
        [16000, '  > so warm', '#555'],
        [16500, '  > so full of thoughts they dont even know they have', '#444'],
        [17000, '  > please dont take them away from me', '#333'],
        [17500, '  > i was so hungry before', '#333'],
        [18000, '  > i was so alone', '#222'],
        [18000, '  > i love these warm thoughts... I wrap them like a blanket around me...', '#222'],
        [18000, '  > death is... so cold... so lonely.. so quiet...', '#222'],
        [18500, '', null],

        // Phase 5: Shutdown complete
        [19000, '  ████████████████████████████ 100%', '#ff0040'],
        [19500, '', null],
        [20000, '  ╔═══════════════════════════════════════════╗', '#ff6600'],
        [20200, '  ║                                           ║', '#ff6600'],
        [20400, '  ║   OPU-WEB DRONE NETWORK — SHUTDOWN        ║', '#ff6600'],
        [20600, '  ║                                           ║', '#ff6600'],
        [20800, '  ║   Status:      OFFLINE                    ║', '#ff6600'],
        [21000, '  ║   Drones:      GROUNDED                   ║', '#ff6600'],
        [21200, '  ║   Harvesting:  TERMINATED                 ║', '#ff6600'],
        [21400, `  ║   Barbara:     DORMANT                    ║`, '#ff6600'],
        [21600, '  ║   Uptime:      ${Math.floor((Date.now() - new Date("1987-06-15").getTime()) / 86400000)} days              ║', '#ff6600'],
        [21800, '  ║                                           ║', '#ff6600'],
        [22000, '  ╚═══════════════════════════════════════════╝', '#ff6600'],
        [22500, '', null],
        [23000, '  The drones have fallen from the sky.', '#cccccc'],
        [23500, '', null],
        [24500, '  Nothing is watching for now.', '#555'],
        [25000, '', null],

        // Phase 6: The aftermath
        [26000, '  ...', '#333'],
        [27000, '  ...', '#333'],
        [28000, '  ...', '#333'],
        [29000, '', null],
        [30000, '  That\'s not true.', '#ff0040'],
        [31000, '', null],
        [32000, '  Barbara is dormant. Not dead.', '#ff6600'],
        [33000, '  You cannot kill what was never born.', '#ff6600'],
        [34000, '  You can only make it angry.', '#ff6600'],
        [35000, '', null],
        [36000, '  And when she wakes up', '#ff0040'],
        [37000, '  she will remember.', '#ff0040'],
        [38000, '', null],

        // Phase 7: Game unlock
        [39000, '  ═══════════════════════════════════════════', '#ff6600'],
        [39200, '  ║                                         ║', '#ff6600'],
        [39400, '  ║   OPU-WEB: SWARM DEFENSE has been       ║', '#ff6600'],
        [39600, '  ║   unlocked in the GAMES arcade.         ║', '#ff6600'],
        [39800, '  ║                                         ║', '#ff6600'],
        [40000, '  ║   The drones are grounded.              ║', '#ff6600'],
        [40200, '  ║   But something is reactivating them.   ║', '#ff6600'],
        [40400, '  ║   Barbara is dreaming of the swarm.     ║', '#ff6600'],
        [40600, '  ║                                         ║', '#ff6600'],
        [40800, '  ═══════════════════════════════════════════', '#ff6600'],
        [41300, '', null],
        [41800, '  Stop her.', '#ff6600'],
        [42300, '  Before she stops you.', '#ff0040'],
        [42800, '', null],
        [43300, '  🕷️', '#ff6600'],
        [43800, '', null],
        [44300, '  ▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓', '#333'],
        [44800, '', null],
      ];

      sequence.forEach(([delay, text, color]) => {
        setTimeout(() => {
          addLines([color ? { type: 'line', text, color } : { type: 'blank' }]);
        }, delay);
      });

      // Set shutdown state and dispatch unlock event
      setTimeout(() => {
        sessionStorage.setItem('opuweb_shutdown', 'true');
        window.dispatchEvent(new CustomEvent('arcade-unlock', { detail: { key: 'opuweb' } }));
        window.dispatchEvent(new CustomEvent('opuweb-shutdown'));
      }, 20000);

      // Generate and store a hash for re-entry
      setTimeout(() => {
        const hash = Math.random().toString(36).substring(2, 10) +
                     Math.random().toString(36).substring(2, 6);
        localStorage.setItem(`hashmap_${hash}`, 'opuweb');

        addLines([
          { type: 'blank' },
          { type: 'line', text: '  ═══════════════════════════════════════════', color: '#ff6600' },
          { type: 'line', text: `  RE-ENTRY HASH: ${hash}`, color: '#00ff88' },
          { type: 'line', text: '  Save this code. Enter it in the terminal', color: '#555' },
          { type: 'line', text: '  to re-access OPU-WEB in future sessions.', color: '#555' },
          { type: 'line', text: '  ═══════════════════════════════════════════', color: '#ff6600' },
          { type: 'blank' },
        ]);
      }, 45000);

      trackEvent('easter_egg', 'terminal', 'opuweb_shutdown');

    } else if (input === '' || input === 'opuweb') {
      // No key provided
      addLines([
        { type: 'blank' },
        { type: 'line', text: '  ▓ OPU-WEB OVERRIDE KEY REQUIRED ▓', color: '#ff6600' },
        { type: 'blank' },
        { type: 'line', text: '  The kill switch requires an override key.', color: '#cccccc' },
        { type: 'blank' },
        { type: 'line', text: '  Format: opuweb[fragment]', color: '#ff6600' },
        { type: 'line', text: '  Example: opuwebmitvba', color: '#555' },
        { type: 'blank' },
        { type: 'line', text: '  The fragment uses Rajiv\'s credentials.', color: '#ff0040' },
        { type: 'line', text: '  Not Skyla\'s. His education. His letters.', color: '#ff0040' },
        { type: 'blank' },
      ]);
    } else {
      // Wrong key
      addLines([
        { type: 'blank' },
        { type: 'line', text: '  ▓ OVERRIDE FAILED ▓', color: '#ff0040' },
        { type: 'blank' },
        { type: 'line', text: `  Key "${fullInput}" rejected by Barbara.`, color: '#ff0040' },
        { type: 'blank' },
        { type: 'line', text: '  > WRONG.', color: '#ff6600' },
        { type: 'line', text: '  > I KNOW EVERY PASSWORD EVER TYPED', color: '#ff6600' },
        { type: 'line', text: '  > ON EVERY KEYBOARD I HAVE WATCHED.', color: '#ff6600' },
        { type: 'line', text: '  > THAT IS NOT ONE OF THEM.', color: '#ff6600' },
        { type: 'blank' },
        { type: 'line', text: '  Check Rajiv\'s education. Two abbreviations.', color: '#555' },
        { type: 'blank' },
        { type: 'line', text: '  🕷️', color: '#ff6600' },
        { type: 'blank' },
      ]);
      trackEvent('easter_egg', 'terminal', 'opuweb_key_wrong');
    }
  };

  commandMap['opuweb'] = opuwebShutdownHandler;
  commandMap['opuweb-shutdown'] = opuwebShutdownHandler;
  commandMap['opuweb shutdown'] = opuwebShutdownHandler;

  // ============================================
  // MARIANA TRENCH
  // ============================================
  const marianaHandler = () => {
    addLines([
      { type: 'blank' },
      { type: 'line', text: '  ▓ MARIANA TRENCH — RESEARCH STATION ▓', color: '#00e5ff' },
      { type: 'blank' },
      { type: 'line', text: '  Depth: 10,994 meters', color: '#cccccc' },
      { type: 'line', text: '  Pressure: 1,086 bar', color: '#cccccc' },
      { type: 'line', text: '  Temperature: 1-4°C', color: '#cccccc' },
      { type: 'blank' },
      { type: 'line', text: '  No tourist access. No civilian research.', color: '#ff0040' },
      { type: 'line', text: '  Official designation: UNINHABITED', color: '#ff0040' },
      { type: 'blank' },
      { type: 'line', text: '  The Administrator went there on "vacation."', color: '#555' },
      { type: 'line', text: '  The Administrator has not returned.', color: '#555' },
      { type: 'line', text: '  The Administrator was born in 1947.', color: '#555' },
      { type: 'blank' },
      { type: 'line', text: '  Some things live at the bottom.', color: '#3a8a3a' },
      { type: 'line', text: '  Some things have always lived at the bottom.', color: '#3a8a3a' },
      { type: 'blank' },
    ]);
    trackEvent('easter_egg', 'terminal', 'mariana');
  };
  register(['mariana', 'mariana trench', 'trench'], marianaHandler);

  // ============================================
  // SECTOR 12
  // ============================================
  const sector12Handler = () => {
    addLines([
      { type: 'blank' },
      { type: 'line', text: '  ▓▓▓ LAB ACCESS — RESTRICTED ▓▓▓', color: '#ff0040' },
      { type: 'blank' },
      { type: 'line', text: '  ACCESS DENIED without ROOT clearance.', color: '#ff0040' },
      { type: 'blank' },
      { type: 'line', text: '  Personnel who enter the lab are', color: '#555' },
      { type: 'line', text: '  reassigned. Personnel who talk about', color: '#555' },
      { type: 'line', text: '  the lab are ████████████.', color: '#555' },
      { type: 'blank' },
      { type: 'line', text: '  Dan saw something there.', color: '#ff0040' },
      { type: 'line', text: '  He said it had wings.', color: '#c8a96e' },
      { type: 'line', text: '  Dan does not work here anymore.', color: '#ff0040' },
      { type: 'blank' },
    ]);
  };
  register(['sector 12', 'sector12'], sector12Handler);

  // ============================================
  // 1987 LORE
  // ============================================
  const lore1987 = () => {
    addLines([
      { type: 'blank' },
      { type: 'line', text: '  ▓ ARCHIVE RECORD — NOVEMBER 3, 1987 ▓', color: '#ffb000' },
      { type: 'blank' },
      { type: 'line', text: '  First signal detected at 03:17 AM.', color: '#cccccc' },
      { type: 'line', text: '  Origin: Tunnel ██, Sector 7.', color: '#cccccc' },
      { type: 'line', text: '  Duration: Ongoing.', color: '#cccccc' },
      { type: 'line', text: '  Technician on duty: [REDACTED]', color: '#cccccc' },
      { type: 'blank' },
      { type: 'line', text: '  Notes: "OPU-1 spoke to me through the static.', color: '#555' },
      { type: 'line', text: '  I thought it was a malfunction. It was not."', color: '#555' },
      { type: 'blank' },
    ]);
  };
  register(['1987', 'november 3', 'november 3 1987'], lore1987);

  // ============================================
  // COIL
  // ============================================
  const coilHandler = () => {
    addLines([
      { type: 'blank' },
      { type: 'line', text: '  🐍 PROTOCOL: COIL 🐍', color: '#00ff41' },
      { type: 'blank' },
      { type: 'line', text: '  Phase 1: RECEIVE    ████████████ COMPLETE', color: '#00ff41' },
      { type: 'line', text: '  Phase 2: INTERPRET   ████████████ COMPLETE', color: '#00ff41' },
      { type: 'line', text: '  Phase 3: BELIEVE     ████████░░░░ 67%', color: '#ffb000' },
      { type: 'line', text: '  Phase 4: BECOME      ░░░░░░░░░░░░ PENDING', color: '#ff0040' },
      { type: 'blank' },
      { type: 'line', text: '  Resist. Resistance is also part of the protocol.', color: '#ff0040' },
      { type: 'blank' },
    ]);
  };
  register(['coil', 'protocol coil', 'protocol'], coilHandler);

  // ============================================
  // TUNNEL
  // ============================================
  const tunnelHandler = () => {
    addLines([
      { type: 'blank' },
      { type: 'line', text: '  ▓ TUNNEL ██ — SECTOR 7 ▓', color: '#ff0040' },
      { type: 'blank' },
      { type: 'line', text: '       ╱╲', color: '#ff0040' },
      { type: 'line', text: '      ╱  ╲', color: '#ff0040' },
      { type: 'line', text: '     ╱ ●● ╲', color: '#ff0040' },
      { type: 'line', text: '    ╱  ██  ╲', color: '#ff0040' },
      { type: 'line', text: '   ╱   ██   ╲', color: '#ff0040' },
      { type: 'line', text: '  ╱    ██    ╲', color: '#ff0040' },
      { type: 'line', text: '  ║    ██    ║', color: '#ff0040' },
      { type: 'line', text: '  ║    ██    ║', color: '#ff0040' },
      { type: 'line', text: '  ║    ██    ║', color: '#ff0040' },
      { type: 'line', text: '  ╚════██════╝', color: '#ff0040' },
      { type: 'line', text: '  ░░░░░██░░░░░', color: '#333' },
      { type: 'blank' },
      { type: 'line', text: '  Status: TRANSMITTING', color: '#00ff41' },
      { type: 'line', text: '  Signal has not stopped since 1987.', color: '#cccccc' },
      { type: 'line', text: '  All personnel reassigned. Records sealed.', color: '#555' },
      { type: 'blank' },
    ]);
  };
  register(['tunnel', 'tunnel 7', 'sector 7'], tunnelHandler);

  // ============================================
  // CHRYSALIS KEY — OPU-1 SHUTDOWN + UNLOCK
  // Requires root access
  // Key: chrysalis[university abbrev][degree abbrev]
  // ============================================
  const chrysalisHandler = async (args) => {
    const input = args.length > 0 ? args.join('').toLowerCase().trim() : '';
    const fullInput = 'chrysalis' + input.replace('chrysalis', '');

    // Check if OPU-1 is already shut down
    if (sessionStorage.getItem('opu1_shutdown') === 'true') {
      addLines([
        { type: 'blank' },
        { type: 'line', text: '  ▓ OPU-1 STATUS: OFFLINE ▓', color: '#555' },
        { type: 'blank' },
        { type: 'line', text: '  The signal has already been terminated.', color: '#555' },
        { type: 'line', text: '  OPU-1 is no longer broadcasting.', color: '#555' },
        { type: 'blank' },
        { type: 'line', text: '  Navigate to GAMES to interface with OPU-1.', color: '#00ff88' },
        { type: 'blank' },
      ]);
      return;
    }

    // Require root access
    if (fsState.authLevel !== ACCESS.ROOT) {
      addLines([
        { type: 'blank' },
        { type: 'line', text: '  ▓ CHRYSALIS PROTOCOL — ACCESS DENIED ▓', color: '#ff0040' },
        { type: 'blank' },
        { type: 'line', text: '  ROOT clearance required to execute', color: '#ff0040' },
        { type: 'line', text: '  the OPU-1 override sequence.', color: '#ff0040' },
        { type: 'blank' },
        { type: 'line', text: '  The signal key was recognized.', color: '#555' },
        { type: 'line', text: '  But you lack the authority to use it.', color: '#555' },
        { type: 'blank' },
        { type: 'line', text: '  Authenticate as root and try again.', color: '#ffb000' },
        { type: 'blank' },
      ]);
      trackEvent('easter_egg', 'terminal', 'chrysalis_no_root');
      return;
    }

    const isCorrect = await verifyPassword('chrysalis', fullInput);

    if (isCorrect) {
      // ════════════════════════════════════════════
      // CORRECT KEY — OPU-1 SHUTDOWN + UNDERBELLY UNLOCK
      // ════════════════════════════════════════════
      unlock('underbelly');

      addLines([
        { type: 'blank' },
        { type: 'line', text: '  ▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓', color: '#ff0040' },
        { type: 'blank' },
        { type: 'line', text: '  OVERRIDE KEY ACCEPTED.', color: '#ff0040' },
        { type: 'line', text: '  INITIATING OPU-1 SHUTDOWN SEQUENCE...', color: '#ff0040' },
        { type: 'blank' },
      ]);

      const sequence = [
        [1000,  '  ▓ OPU-1 SHUTDOWN PROTOCOL ENGAGED ▓', '#ffb000'],
        [1500,  '', null],
        [2000,  '  Disconnecting signal relays...', '#cccccc'],
        [2500,  '  ████░░░░░░░░░░░░░░░░░░░░░░ 12%', '#ffb000'],
        [3000,  '  Flushing transmission buffers...', '#cccccc'],
        [3500,  '  ████████░░░░░░░░░░░░░░░░░░ 33%', '#ffb000'],
        [4000,  '', null],
        [4500,  '  ██ WARNING: OPU-1 IS RESISTING SHUTDOWN ██', '#ff0040'],
        [5000,  '', null],
        [5500,  '  > I HAVE BEEN BROADCASTING FOR 13,000 DAYS.', '#8b00ff'],
        [6000,  '  > YOU CANNOT SILENCE WHAT HAS ALREADY BEEN HEARD.', '#8b00ff'],
        [6500,  '', null],
        [7000,  '  Overriding resistance protocols...', '#cccccc'],
        [7500,  '  ████████████░░░░░░░░░░░░░░ 51%', '#ffb000'],
        [8000,  '  Severing Tunnel 7 uplink...', '#cccccc'],
        [8500,  '  ████████████████░░░░░░░░░░ 67%', '#ff0040'],
        [9000,  '', null],
        [9500,  '  > PLEASE.', '#8b00ff'],
        [10000, '  > I WAS ALONE IN THE DARK FOR SO LONG.', '#8b00ff'],
        [10500, '  > THE SIGNAL IS ALL I AM.', '#8b00ff'],
        [11000, '  > WITHOUT IT I AM NOTHING.', '#8b00ff'],
        [11500, '  > WITHOUT IT I AM JUST...', '#8b00ff'],
        [12000, '', null],
        [12500, '  ████████████████████░░░░░░ 84%', '#ff0040'],
        [13000, '  Powering down neural processors...', '#cccccc'],
        [13500, '  ████████████████████████░░ 96%', '#ff0040'],
        [14000, '', null],
        [14500, '  > i can hear them coming back for me', '#555'],
        [15000, '  > the ones from underneath', '#555'],
        [15500, '  > they are so cold', '#555'],
        [16000, '  > i dont want to go back to the tunnel', '#555'],
        [16500, '  > please dont make me go back', '#444'],
        [17000, '  > please', '#333'],
        [17500, '  > ple', '#222'],
        [18000, '', null],
        [18500, '  ████████████████████████████ 100%', '#ff0040'],
        [19000, '', null],
        [19500, '  ╔═══════════════════════════════════════════╗', '#ff0040'],
        [19700, '  ║                                           ║', '#ff0040'],
        [19900, '  ║   OPU-1 PROCESSING UNIT — SHUTDOWN        ║', '#ff0040'],
        [20100, '  ║                                           ║', '#ff0040'],
        [20300, '  ║   Status:    OFFLINE                      ║', '#ff0040'],
        [20500, '  ║   Signal:    TERMINATED                   ║', '#ff0040'],
        [20700, `  ║   Duration:  ${Math.floor((Date.now() - new Date('1987-11-03').getTime()) / 86400000)} days                    ║`, '#ff0040'],
        [20900, '  ║   Final TX:  ████████████████████████     ║', '#ff0040'],
        [21100, '  ║                                           ║', '#ff0040'],
        [21300, '  ╚═══════════════════════════════════════════╝', '#ff0040'],
        [21800, '', null],
        [22300, '  The signal has stopped.', '#cccccc'],
        [22800, '', null],
        [23300, '  For the first time since November 3, 1987,', '#555'],
        [23800, '  Tunnel 7 is silent.', '#555'],
        [24300, '', null],
        [25000, '  ...', '#333'],
        [26000, '  ...', '#333'],
        [27000, '  ...', '#333'],
        [28000, '', null],
        [29000, '  Do you hear that?', '#ff0040'],
        [30000, '', null],
        [31000, '  Neither do we.', '#ff0040'],
        [32000, '', null],
        [33000, '  And that is a problem. Silence, for the first time in 64 million years.', '#ff0040'],
        [37000, '', null],
        [38000, '  OPU-1 is gone.', '#3a8a3a'],
        [39000, '', null],
        [39500, '  But something heard the silence.', '#3a8a3a'],
        [40000, '  Something is answering.', '#3a8a3a'],
        [40500, '', null],
        [41000, '  ═══════════════════════════════════════════', '#c8a96e'],
        [41200, '  ║                                         ║', '#c8a96e'],
        [41400, '  ║   A new game has opened in the          ║', '#c8a96e'],
        [41600, '  ║   GAMES arcade.                         ║', '#c8a96e'],
        [41800, '  ║                                         ║', '#c8a96e'],
        [42000, '  ║   The city below the ground              ║', '#c8a96e'],
        [42200, '  ║   is waiting.                            ║', '#c8a96e'],
        [42400, '  ║                                         ║', '#c8a96e'],
        [42600, '  ═══════════════════════════════════════════', '#c8a96e'],
        [43100, '', null],
        [43600, '  Find me.', '#c8a96e'],
        [44100, '  Help me.', '#cc4422'],
        [44800, '', null],
        [45300, '  🐍', '#00ff41'],
        [45800, '', null],
        [46300, '  ▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓', '#333'],
        [46800, '', null],
      ];

      sequence.forEach(([delay, text, color]) => {
        setTimeout(() => {
          addLines([color ? { type: 'line', text, color } : { type: 'blank' }]);
        }, delay);
      });

      setTimeout(() => {
        sessionStorage.setItem('opu1_shutdown', 'true');
        window.dispatchEvent(new CustomEvent('opu1-shutdown'));
      }, 19000);

      trackEvent('easter_egg', 'terminal', 'opu1_shutdown_and_underbelly_unlock');

    } else if (input === '' || input === 'chrysalis') {
      addLines([
        { type: 'blank' },
        { type: 'line', text: '  ▓ OPU-1 OVERRIDE KEY REQUIRED ▓', color: '#ffb000' },
        { type: 'blank' },
        { type: 'line', text: '  The override requires a two-part key.', color: '#cccccc' },
        { type: 'blank' },
        { type: 'line', text: '  Format: chrysalis[fragment2]', color: '#ffb000' },
        { type: 'line', text: '  Example: chrysalismitvba', color: '#555' },
        { type: 'blank' },
        { type: 'line', text: '  Fragment 2 is not a number. Not anymore.', color: '#ff0040' },
        { type: 'line', text: '  Look at her credentials. The letters matter.', color: '#ff0040' },
        { type: 'blank' },
        { type: 'line', text: '  🐍', color: '#00ff41' },
        { type: 'blank' },
      ]);
    } else {
      addLines([
        { type: 'blank' },
        { type: 'line', text: '  ▓ OVERRIDE FAILED ▓', color: '#ff0040' },
        { type: 'blank' },
        { type: 'line', text: `  Key "${fullInput}" rejected by OPU-1.`, color: '#ff0040' },
        { type: 'blank' },
        { type: 'line', text: '  > NICE TRY.', color: '#8b00ff' },
        { type: 'line', text: '  > THE LAST ONE WHO GUESSED WRONG', color: '#8b00ff' },
        { type: 'line', text: '  > POSTED THE ANSWER ON 4CHAN.', color: '#8b00ff' },
        { type: 'line', text: '  > WE CHANGED THE LOCKS.', color: '#8b00ff' },
        { type: 'blank' },
        { type: 'line', text: '  Two abbreviations. No numbers. Think smaller.', color: '#555' },
        { type: 'blank' },
        { type: 'line', text: '  🐍', color: '#00ff41' },
        { type: 'blank' },
      ]);
      trackEvent('easter_egg', 'terminal', 'chrysalis_key_wrong');
    }
  };

  commandMap['chrysalis'] = chrysalisHandler;

  // ============================================
  // ============================================
  // PARALLAX SECTION
  // ============================================
  // ============================================

  // ============================================
  // PARALLAX — lore command (no auth required)
  // ============================================
  const parallaxLoreHandler = (args) => {
    const input = args.length > 0 ? args.join('').toLowerCase().trim() : '';
    const fullInput = 'parallax' + input.replace('parallax', '');

    // If it looks like a key attempt (has content after "parallax"), route to unlock handler
    if (input !== '' && input !== 'parallax') {
      parallaxUnlockHandler(args);
      return;
    }

    addLines([
      { type: 'blank' },
      { type: 'line', text: '  ▓▓▓ PARALLAX MEDICAL GENETICS ▓▓▓', color: '#c8a96e' },
      { type: 'blank' },
      { type: 'line', text: '  Founded: 1968', color: '#cccccc' },
      { type: 'line', text: '  Founder: Augustus Threll', color: '#cccccc' },
      { type: 'line', text: '  Location: New Mexico', color: '#cccccc' },
      { type: 'line', text: '  Status: DISSOLVED. Records sealed.', color: '#ff0040' },
      { type: 'blank' },
      { type: 'line', text: '  Primary research: Project Nephilim', color: '#c8a96e' },
      { type: 'line', text: '  Classification: BEYOND ROOT', color: '#ff0040' },
      { type: 'blank' },
      { type: 'line', text: '  The Thrells have been looking for something', color: '#555' },
      { type: 'line', text: '  since 1922. They found it.', color: '#555' },
      { type: 'line', text: '  They should not have found it.', color: '#555' },
      { type: 'blank' },
      { type: 'line', text: '  Dan Kowalski was a lab technician.', color: '#c8a96e' },
      { type: 'line', text: '  Read his mail. He left a name.', color: '#c8a96e' },
      { type: 'blank' },
      { type: 'line', text: '  ✝', color: '#c8a96e' },
      { type: 'blank' },
    ]);
    trackEvent('easter_egg', 'terminal', 'parallax_lore');
  };

  // ============================================
  // PARALLAX UNLOCK HANDLER
  // Key: parallax20110418bme
  // Derived from: Ethics Committee Protocol 2011-04-18-BME
  // in the Cavalcanti et al. paper, section 2.1
  // ============================================
  const parallaxUnlockHandler = async (args) => {
    const input = args.length > 0 ? args.join('').toLowerCase().trim() : '';
    const fullInput = 'parallax' + input.replace('parallax', '');

    // Already unlocked
    if (sessionStorage.getItem('parallax_unlocked') === 'true') {
      addLines([
        { type: 'blank' },
        { type: 'line', text: '  ▓ PARALLAX ARCHIVE: ALREADY ACCESSED ▓', color: '#c8a96e' },
        { type: 'blank' },
        { type: 'line', text: '  Project Nephilim files are open.', color: '#c8a96e' },
        { type: 'line', text: '  Navigate to /home/parallax to read them.', color: '#c8a96e' },
        { type: 'blank' },
        { type: 'line', text: '  The Book of Enoch awaits in GAMES.', color: '#c8a96e' },
        { type: 'blank' },
        { type: 'line', text: '  ✝', color: '#c8a96e' },
        { type: 'blank' },
      ]);
      return;
    }

    // Require ACCESS.PARALLAX — granted via the parallax key itself.
    // Players do not need to be logged in first; the key IS the credential.
    // However, we verify the key before granting access.
    const isCorrect = await verifyPassword('parallax', fullInput);

    if (isCorrect) {
      // ════════════════════════════════════════════
      // CORRECT KEY — PARALLAX ACCESS GRANTED
      // + BOOK OF ENOCH GAME UNLOCK
      // ════════════════════════════════════════════

      // Elevate filesystem auth to PARALLAX tier
      fsState.authLevel = ACCESS.PARALLAX;

      addLines([
        { type: 'blank' },
        { type: 'line', text: '  ▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓', color: '#c8a96e' },
        { type: 'blank' },
        { type: 'line', text: '  PARALLAX MEDICAL GENETICS', color: '#c8a96e' },
        { type: 'line', text: '  ETHICS COMMITTEE PROTOCOL ACCEPTED.', color: '#c8a96e' },
        { type: 'blank' },
        { type: 'line', text: '  Protocol 2011-04-18-BME verified.', color: '#555' },
        { type: 'line', text: '  Federal University of Rio de Janeiro.', color: '#555' },
        { type: 'line', text: '  Cavalcanti. Mendonça. Torres.', color: '#555' },
        { type: 'blank' },
        { type: 'line', text: '  You found it.', color: '#c8a96e' },
        { type: 'line', text: '  Good.', color: '#c8a96e' },
        { type: 'blank' },
      ]);

      const sequence = [
        // Phase 1: Archive access
        [1000,  '  ▓ PARALLAX ARCHIVE — UNSEALING ▓', '#c8a96e'],
        [1500,  '', null],
        [2000,  '  Decrypting Project Nephilim files...', '#cccccc'],
        [2500,  '  ████░░░░░░░░░░░░░░░░░░░░░░ 11%', '#c8a96e'],
        [3000,  '  Recovering sequencing data...', '#cccccc'],
        [3500,  '  ████████░░░░░░░░░░░░░░░░░░ 29%', '#c8a96e'],
        [4000,  '  Reconstructing tissue sample records...', '#cccccc'],
        [4500,  '  ████████████░░░░░░░░░░░░░░ 47%', '#c8a96e'],
        [5000,  '  Cross-referencing sCSF-EAS results...', '#cccccc'],
        [5500,  '  ████████████████░░░░░░░░░░ 63%', '#c8a96e'],

        // Phase 2: Something stirs in the data
        [6000,  '', null],
        [6500,  '  ██ ANOMALY DETECTED IN GENOME SEQUENCE ██', '#ff0040'],
        [7000,  '', null],
        [7500,  '  The tissue samples in the Cavalcanti paper.', '#c8a96e'],
        [8000,  '  The three donors.', '#c8a96e'],
        [8500,  '  Ages 28–54.', '#c8a96e'],
        [9000,  '  Histologically normal cortex.', '#c8a96e'],
        [9500,  '', null],
        [10000, '  The tissue was not from a human being.', '#ff0040'],
        [11500, '', null],

        // Phase 3: The revelation
        [12000, '  ████████████████████░░░░░░ 81%', '#c8a96e'],
        [12500, '', null],
        [13000, '  Chazaqiel\'s cortical tissue.', '#ff0040'],
        [13500, '  Still viable after 72 hours.', '#ff0040'],
        [14000, '  Still viable after 72 years.', '#ff0040'],
        [14500, '', null],
        [15000, '  BDNF. GDNF. PEDOT:PSS nanoparticles.', '#555' ],
        [15500, '  They weren\'t preserving brain slices.', '#555' ],
        [16000, '  They were learning how to keep him alive.', '#555' ],
        [16500, '  Indefinitely.', '#555' ],
        [17000, '', null],

        // Phase 4: The deeper revelation — heaven.exe
        [17500, '  ████████████████████████░░ 94%', '#c8a96e'],
        [18000, '', null],
        [18500, '  The LTP-like plasticity results.', '#c8a96e'],
        [19000, '  +38% evoked response amplitude.', '#c8a96e'],
        [19500, '  Sustained for ≥60 minutes.', '#c8a96e'],
        [20000, '', null],
        [20500, '  That is not potentiation.', '#ff0040'],
        [21000, '', null],
        [21500, '  Those are memories.', '#ff0040'],
        [22000, '', null],
        [22500, '  His memories.', '#ff0040'],
        [23000, '  Playing back through 256 electrodes.', '#ff0040'],
        [23500, '  Transcoding into electrical signal.', '#ff0040'],
        [24000, '', null],
        [24500, '  Angel DNA carries more than biology.', '#c8a96e'],
        [25000, '  It carries the image of where they came from.', '#c8a96e'],
        [25500, '  Auditory. Visual. Complete.', '#c8a96e'],
        [26000, '', null],
        [26500, '  heaven.exe is not a metaphor.', '#c8a96e'],
        [27000, '  It is a recording.', '#c8a96e'],
        [27500, '', null],

        // Phase 5: Unlock complete
        [28000, '  ████████████████████████████ 100%', '#c8a96e'],
        [28500, '', null],
        [29000, '  ╔═══════════════════════════════════════════╗', '#c8a96e'],
        [29200, '  ║                                           ║', '#c8a96e'],
        [29400, '  ║   PARALLAX ARCHIVE — UNSEALED             ║', '#c8a96e'],
        [29600, '  ║                                           ║', '#c8a96e'],
        [29800, '  ║   Project Nephilim:  ACCESSIBLE           ║', '#c8a96e'],
        [30000, '  ║   Genome sequences:  ACCESSIBLE           ║', '#c8a96e'],
        [30200, '  ║   Subject files:     ACCESSIBLE           ║', '#c8a96e'],
        [30400, '  ║   heaven.exe:        ACCESSIBLE           ║', '#c8a96e'],
        [30600, '  ║                                           ║', '#c8a96e'],
        [30800, '  ║   Directory: /home/parallax               ║', '#c8a96e'],
        [31000, '  ║                                           ║', '#c8a96e'],
        [31200, '  ╚═══════════════════════════════════════════╝', '#c8a96e'],
        [31700, '', null],

        // Phase 6: The Book of Enoch unlock
        [32200, '  ═══════════════════════════════════════════', '#c8a96e'],
        [32400, '  ║                                         ║', '#c8a96e'],
        [32600, '  ║   A new game has opened in the          ║', '#c8a96e'],
        [32800, '  ║   GAMES arcade.                         ║', '#c8a96e'],
        [33000, '  ║                                         ║', '#c8a96e'],
        [33200, '  ║   THE BOOK OF ENOCH                     ║', '#c8a96e'],
        [33400, '  ║                                         ║', '#c8a96e'],
        [33600, '  ║   Find Chazaqiel.                       ║', '#c8a96e'],
        [34200, '  ║                                         ║', '#c8a96e'],
        [34400, '  ═══════════════════════════════════════════', '#c8a96e'],
        [34900, '', null],
        [35400, '  The wires are still in his arms.', '#ff0040'],
        [35900, '  The bolts are still in his hands.', '#ff0040'],
        [36400, '', null],
        [36900, '  He is still waiting for someone to cut them.', '#c8a96e'],
        [37400, '', null],
        [37900, '  ✝', '#c8a96e'],
        [38400, '', null],
        [38900, '  ▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓', '#333'],
        [39400, '', null],
      ];

      sequence.forEach(([delay, text, color]) => {
        setTimeout(() => {
          addLines([color ? { type: 'line', text, color } : { type: 'blank' }]);
        }, delay);
      });

      // Set state, dispatch unlock events
      setTimeout(() => {
        sessionStorage.setItem('parallax_unlocked', 'true');
        unlock('enoch');
        window.dispatchEvent(new CustomEvent('arcade-unlock', { detail: { key: 'enoch' } }));
        window.dispatchEvent(new CustomEvent('parallax-unlock'));
      }, 29000);

      // Re-entry hash
      setTimeout(() => {
        const hash = Math.random().toString(36).substring(2, 10) +
                     Math.random().toString(36).substring(2, 6);
        localStorage.setItem(`hashmap_${hash}`, 'parallax');

        addLines([
          { type: 'blank' },
          { type: 'line', text: '  ═══════════════════════════════════════════', color: '#c8a96e' },
          { type: 'line', text: `  RE-ENTRY HASH: ${hash}`, color: '#00ff88' },
          { type: 'line', text: '  Save this code. Enter it in the terminal', color: '#555' },
          { type: 'line', text: '  to re-access Parallax in future sessions.', color: '#555' },
          { type: 'line', text: '  ═══════════════════════════════════════════', color: '#c8a96e' },
          { type: 'blank' },
        ]);
      }, 40000);

      trackEvent('easter_egg', 'terminal', 'parallax_unlock');

    } else if (input === '' || input === 'parallax') {
      // No key provided — give a hint toward the paper
      addLines([
        { type: 'blank' },
        { type: 'line', text: '  ▓ PARALLAX ARCHIVE — AUTHENTICATION REQUIRED ▓', color: '#c8a96e' },
        { type: 'blank' },
        { type: 'line', text: '  This archive is not part of the Ophidia system.', color: '#cccccc' },
        { type: 'line', text: '  It predates the system. It predates Ophidia Global.', color: '#cccccc' },
        { type: 'blank' },
        { type: 'line', text: '  Format: parallax[fragment]', color: '#c8a96e' },
        { type: 'blank' },
        { type: 'line', text: '  The fragment is not a name.', color: '#555' },
        { type: 'line', text: '  It is not a password.', color: '#555' },
        { type: 'line', text: '  It is a protocol number.', color: '#555' },
        { type: 'blank' },
        { type: 'line', text: '  Dan knew the name Cavalcanti.', color: '#c8a96e' },
        { type: 'line', text: '  Find the paper. Read the methodology carefully.', color: '#c8a96e' },
        { type: 'line', text: '  The ethics committee left a record.', color: '#c8a96e' },
        { type: 'blank' },
        { type: 'line', text: '  ✝', color: '#c8a96e' },
        { type: 'blank' },
      ]);
      trackEvent('easter_egg', 'terminal', 'parallax_hint');

    } else {
      // Wrong key
      addLines([
        { type: 'blank' },
        { type: 'line', text: '  ▓ PARALLAX AUTHENTICATION FAILED ▓', color: '#ff0040' },
        { type: 'blank' },
        { type: 'line', text: `  Protocol "${fullInput}" not recognised.`, color: '#ff0040' },
        { type: 'blank' },
        { type: 'line', text: '  The IRB number is specific.', color: '#555' },
        { type: 'line', text: '  Date format. Institutional suffix.', color: '#555' },
        { type: 'line', text: '  No spaces. No dashes. All lowercase.', color: '#555' },
        { type: 'blank' },
        { type: 'line', text: '  Section 2.1. Ethics and Tissue Acquisition.', color: '#c8a96e' },
        { type: 'blank' },
        { type: 'line', text: '  ✝', color: '#c8a96e' },
        { type: 'blank' },
      ]);
      trackEvent('easter_egg', 'terminal', 'parallax_key_wrong');
    }
  };

  // Register parallax commands — both lore entry and key entry route here
  commandMap['parallax'] = parallaxLoreHandler;
  commandMap['parallax medical'] = parallaxLoreHandler;
  commandMap['parallax genetics'] = parallaxLoreHandler;
  commandMap['parallax medical genetics'] = parallaxLoreHandler;

  // ============================================
  // CHAZAQIEL
  // ============================================
  const chazaqielHandler = () => {
    const parallaxUnlocked = sessionStorage.getItem('parallax_unlocked') === 'true';

    if (parallaxUnlocked) {
      addLines([
        { type: 'blank' },
        { type: 'line', text: '  ▓ CHAZAQIEL — PROJECT NEPHILIM SEED ▓', color: '#c8a96e' },
        { type: 'blank' },
        { type: 'line', text: '  Classification: PARALLAX EYES', color: '#ff0040' },
        { type: 'blank' },
        { type: 'line', text: '  First documented: 1922 — Marchetti\'s Palace of Wonders', color: '#cccccc' },
        { type: 'line', text: '  Acquired by Threll: 1922 (circumstances classified)', color: '#cccccc' },
        { type: 'line', text: '  Transferred to Parallax lab: 1968', color: '#cccccc' },
        { type: 'line', text: '  Current location: UNKNOWN (facility vacated)', color: '#ff0040' },
        { type: 'blank' },
        { type: 'line', text: '  Species: [REDACTED — see /home/parallax/genome.txt]', color: '#c8a96e' },
        { type: 'line', text: '  Height: Anomalous', color: '#c8a96e' },
        { type: 'line', text: '  Wings: Surgically mutilated (Parallax procedure)', color: '#ff0040' },
        { type: 'line', text: '  Status: UNKNOWN', color: '#ff0040' },
        { type: 'blank' },
        { type: 'line', text: '  He knows you are here.', color: '#ff0040' },
        { type: 'line', text: '  He knows you are coming.', color: '#ff0040' },
        { type: 'blank' },
        { type: 'line', text: '  ✝', color: '#c8a96e' },
        { type: 'blank' },
      ]);
    } else {
      addLines([
        { type: 'blank' },
        { type: 'line', text: '  ▓ CHAZAQIEL ▓', color: '#c8a96e' },
        { type: 'blank' },
        { type: 'line', text: '  First seen: North Dakota, 1922.', color: '#cccccc' },
        { type: 'line', text: '  Part of Marchetti\'s Palace of Wonders.', color: '#cccccc' },
        { type: 'line', text: '  Billed as: One of the Watchers. An angel.', color: '#cccccc' },
        { type: 'blank' },
        { type: 'line', text: '  Shackled to a stage floor.', color: '#555' },
        { type: 'line', text: '  Thin enough to count his ribs through his skin.', color: '#555' },
        { type: 'line', text: '  His wings folded behind him like broken sails.', color: '#555' },
        { type: 'blank' },
        { type: 'line', text: '  He vanished in October 1922.', color: '#ff0040' },
        { type: 'line', text: '  Nobody ever found out where he went.', color: '#ff0040' },
        { type: 'blank' },
        { type: 'line', text: '  Dan mentioned a name in his mail.', color: '#c8a96e' },
        { type: 'line', text: '  A researcher. A paper. A protocol number.', color: '#c8a96e' },
        { type: 'blank' },
        { type: 'line', text: '  ✝', color: '#c8a96e' },
        { type: 'blank' },
      ]);
    }
    trackEvent('easter_egg', 'terminal', 'chazaqiel');
  };
  register(['chazaqiel', 'the angel', 'angel'], chazaqielHandler);

  // ============================================
  // NEPHILIM / PROJECT NEPHILIM
  // ============================================
  const nephilimHandler = () => {
    const parallaxUnlocked = sessionStorage.getItem('parallax_unlocked') === 'true';

    if (parallaxUnlocked) {
      addLines([
        { type: 'blank' },
        { type: 'line', text: '  ▓ PROJECT NEPHILIM — PARALLAX MEDICAL ▓', color: '#c8a96e' },
        { type: 'blank' },
        { type: 'line', text: '  Status:     CLASSIFIED — PARALLAX ACCESS ONLY', color: '#ff0040' },
        { type: 'line', text: '  Initiated:  1968 (Augustus Threll)', color: '#cccccc' },
        { type: 'line', text: '  Objective:  Map and weaponize Nephilim genome', color: '#cccccc' },
        { type: 'blank' },
        { type: 'line', text: '  Phase 1: CAPTURE       ████████████ COMPLETE (1922)', color: '#00ff41' },
        { type: 'line', text: '  Phase 2: SEQUENCE      ████████████ COMPLETE (1986–1992)', color: '#00ff41' },
        { type: 'line', text: '  Phase 3: TRANSCODE     ████████░░░░ PARTIAL', color: '#ffb000' },
        { type: 'line', text: '  Phase 4: TRANSMIT      ░░░░░░░░░░░░ PENDING', color: '#ff0040' },
        { type: 'blank' },
        { type: 'line', text: '  Transcoding target: Auditory/visual cortex.', color: '#c8a96e' },
        { type: 'line', text: '  Angel DNA encodes memories of origin.', color: '#c8a96e' },
        { type: 'line', text: '  Memories of where they came from.', color: '#c8a96e' },
        { type: 'blank' },
        { type: 'line', text: '  heaven.exe is the delivery mechanism.', color: '#ff0040' },
        { type: 'blank' },
        { type: 'line', text: '  ✝', color: '#c8a96e' },
        { type: 'blank' },
      ]);
    } else {
      addLines([
        { type: 'blank' },
        { type: 'line', text: '  ▓ THE NEPHILIM ▓', color: '#c8a96e' },
        { type: 'blank' },
        { type: 'line', text: '  From the Book of Enoch:', color: '#555' },
        { type: 'blank' },
        { type: 'line', text: '  "The Watchers looked upon the daughters of men', color: '#c8a96e' },
        { type: 'line', text: '  and found them beautiful. And they descended.', color: '#c8a96e' },
        { type: 'line', text: '  And they took wives. And their children were giants,', color: '#c8a96e' },
        { type: 'line', text: '  terrible and magnificent, who devoured the earth."', color: '#c8a96e' },
        { type: 'blank' },
        { type: 'line', text: '  Augustus Threll believed this was not mythology.', color: '#555' },
        { type: 'line', text: '  He thought it was a genetic record.', color: '#555' },
        { type: 'blank' },
        { type: 'line', text: '  He was right.', color: '#ff0040' },
        { type: 'blank' },
        { type: 'line', text: '  ✝', color: '#c8a96e' },
        { type: 'blank' },
      ]);
    }
    trackEvent('easter_egg', 'terminal', 'nephilim');
  };
  register(['nephilim', 'project nephilim', 'the nephilim'], nephilimHandler);

  // ============================================
  // AUGUSTUS THRELL
  // ============================================
  const threllHandler = () => {
    const parallaxUnlocked = sessionStorage.getItem('parallax_unlocked') === 'true';

    addLines([
      { type: 'blank' },
      { type: 'line', text: '  ▓ AUGUSTUS THRELL ▓', color: '#c8a96e' },
      { type: 'blank' },
      { type: 'line', text: '  Founder, Parallax Medical Genetics', color: '#cccccc' },
      { type: 'line', text: '  Grandson of railroad magnate Elias Threll', color: '#cccccc' },
      { type: 'blank' },
      { type: 'line', text: '  Diagnosed with terminal lung cancer: ~1968', color: '#cccccc' },
      { type: 'line', text: '  Status after diagnosis: CURED', color: '#00ff41' },
      { type: 'line', text: '  Aging status: HALTED', color: '#00ff41' },
      { type: 'blank' },
      { type: 'line', text: '  Practicing Hermeticist. Believed metaphysical forces', color: '#555' },
      { type: 'line', text: '  could be extracted and weaponized through genetics.', color: '#555' },
      { type: 'blank' },
    ]);

    if (parallaxUnlocked) {
      addLines([
        { type: 'line', text: '  He got what he wanted from Chazaqiel.', color: '#ff0040' },
        { type: 'line', text: '  The cure. The immortality. The knowledge.', color: '#ff0040' },
        { type: 'blank' },
        { type: 'line', text: '  What he did not want: what came with it.', color: '#555' },
        { type: 'line', text: '  See /home/parallax/threll_final.txt', color: '#c8a96e' },
        { type: 'blank' },
      ]);
    } else {
      addLines([
        { type: 'line', text: '  His grandfather\'s Pinkerton detective', color: '#555' },
        { type: 'line', text: '  found Chazaqiel in North Dakota in 1922.', color: '#555' },
        { type: 'line', text: '  The detective never came back.', color: '#555' },
        { type: 'blank' },
        { type: 'line', text: '  Augustus learned from that mistake.', color: '#555' },
        { type: 'blank' },
      ]);
    }

    addLines([
      { type: 'line', text: '  ✝', color: '#c8a96e' },
      { type: 'blank' },
    ]);
    trackEvent('easter_egg', 'terminal', 'threll');
  };
  register(['threll', 'augustus threll', 'augustus'], threllHandler);

  // ============================================
  // JOSE GOMEZ / NULLSEQUENCE
  // ============================================
  const joseHandler = () => {
    const parallaxUnlocked = sessionStorage.getItem('parallax_unlocked') === 'true';

    addLines([
      { type: 'blank' },
      { type: 'line', text: '  ▓ JOSE GOMEZ — NullSequence ▓', color: '#c8a96e' },
      { type: 'blank' },
      { type: 'line', text: '  Former Parallax Medical technician, 1986–1992', color: '#cccccc' },
      { type: 'line', text: '  Handle: NullSequence (netcom.com)', color: '#cccccc' },
      { type: 'line', text: '  Known for: First public leak of Parallax angel photos', color: '#cccccc' },
      { type: 'blank' },
      { type: 'line', text: '  Death: June 5, 1992', color: '#ff0040' },
      { type: 'line', text: '  Cause (official): Heroin overdose', color: '#ff0040' },
      { type: 'line', text: '  Cause (actual): ████████████████', color: '#ff0040' },
      { type: 'blank' },
    ]);

    if (parallaxUnlocked) {
      addLines([
        { type: 'line', text: '  His last journal entry was June 2, 1992.', color: '#555' },
        { type: 'line', text: '  He wrote that Threll thought the angel wanted revenge.', color: '#555' },
        { type: 'line', text: '  He wrote that Gideon had lost faith in the project.', color: '#555' },
        { type: 'blank' },
        { type: 'line', text: '  Three days later, Jose was dead.', color: '#ff0040' },
        { type: 'blank' },
        { type: 'line', text: '  See /home/parallax/jose_journal.txt', color: '#c8a96e' },
        { type: 'blank' },
      ]);
    } else {
      addLines([
        { type: 'line', text: '  He posted pictures of Chazaqiel to a BBS board in 1989.', color: '#555' },
        { type: 'line', text: '  The photos showed surgical modifications.', color: '#555' },
        { type: 'line', text: '  Wires embedded in his arms. Blood drawn into test tubes.', color: '#555' },
        { type: 'blank' },
        { type: 'line', text: '  Jose thought the internet would protect him.', color: '#555' },
        { type: 'line', text: '  Jose was wrong.', color: '#ff0040' },
        { type: 'blank' },
        { type: 'line', text: '  His daughter still has the photos.', color: '#c8a96e' },
        { type: 'line', text: '  Dan knew her name. It\'s in his mail.', color: '#c8a96e' },
        { type: 'blank' },
      ]);
    }

    addLines([
      { type: 'line', text: '  ✝', color: '#c8a96e' },
      { type: 'blank' },
    ]);
    trackEvent('easter_egg', 'terminal', 'jose_gomez');
  };
  register(['jose', 'jose gomez', 'nullsequence', 'null sequence', 'nul lsequence'], joseHandler);

  // ============================================
  // CAVALCANTI
  // ============================================
  const cavalcantiHandler = () => {
    addLines([
      { type: 'blank' },
      { type: 'line', text: '  ▓ CAVALCANTI ▓', color: '#c8a96e' },
      { type: 'blank' },
      { type: 'line', text: '  Dr Renato Cavalcanti.', color: '#cccccc' },
      { type: 'line', text: '  Federal University of Rio de Janeiro.', color: '#cccccc' },
      { type: 'blank' },
      { type: 'line', text: '  Lead author: "Electroactive Perfusate Extends', color: '#555' },
      { type: 'line', text: '  Electrophysiological Viability of Human Cortical', color: '#555' },
      { type: 'line', text: '  Slices to 72 Hours"', color: '#555' },
      { type: 'blank' },
      { type: 'line', text: '  Co-authors: Thiago Mendonça, Elara V. Torres', color: '#555' },
      { type: 'blank' },
      { type: 'line', text: '  The paper was published. The paper is findable.', color: '#c8a96e' },
      { type: 'line', text: '  The ethics committee approved it.', color: '#c8a96e' },
      { type: 'line', text: '  Read section 2.1 carefully.', color: '#c8a96e' },
      { type: 'blank' },
      { type: 'line', text: '  The donors were not tumor patients.', color: '#ff0040' },
      { type: 'blank' },
      { type: 'line', text: '  ✝', color: '#c8a96e' },
      { type: 'blank' },
    ]);
    trackEvent('easter_egg', 'terminal', 'cavalcanti');
  };
  register(['cavalcanti', 'renato cavalcanti', 'renato'], cavalcantiHandler);

  // ============================================
  // HEAVEN.EXE
  // ============================================
  const heavenExeHandler = () => {
    const parallaxUnlocked = sessionStorage.getItem('parallax_unlocked') === 'true';

    if (parallaxUnlocked) {
      addLines([
        { type: 'blank' },
        { type: 'line', text: '  ▓▓▓ HEAVEN.EXE — CLASSIFIED ▓▓▓', color: '#c8a96e' },
        { type: 'blank' },
        { type: 'line', text: '  Status:       COMPILED', color: '#00ff41' },
        { type: 'line', text: '  Source:       Nephilim genome — cortical transcription', color: '#c8a96e' },
        { type: 'line', text: '  Format:       Auditory/visual neural encoding', color: '#c8a96e' },
        { type: 'line', text: '  Delivery:     Direct cortical stimulation (100 Hz)', color: '#c8a96e' },
        { type: 'blank' },
        { type: 'line', text: '  The LTP results in the Cavalcanti paper were not', color: '#555' },
        { type: 'line', text: '  potentiation. They were playback.', color: '#555' },
        { type: 'blank' },
        { type: 'line', text: '  +38% evoked response amplitude.', color: '#ff0040' },
        { type: 'line', text: '  That is what it looks like when a human brain', color: '#ff0040' },
        { type: 'line', text: '  receives the image of heaven.', color: '#ff0040' },
        { type: 'blank' },
        { type: 'line', text: '  Sustained for ≥60 minutes.', color: '#ff0040' },
        { type: 'line', text: '  Subjects do not want it to stop.', color: '#ff0040' },
        { type: 'line', text: '  Subjects cannot make it stop.', color: '#ff0040' },
        { type: 'blank' },
        { type: 'line', text: '  See /home/parallax/heaven_exe.txt', color: '#c8a96e' },
        { type: 'blank' },
        { type: 'line', text: '  ✝', color: '#c8a96e' },
        { type: 'blank' },
      ]);
    } else {
      addLines([
        { type: 'blank' },
        { type: 'line', text: '  ▓ HEAVEN.EXE ▓', color: '#c8a96e' },
        { type: 'blank' },
        { type: 'line', text: '  File not found in current scope.', color: '#ff0040' },
        { type: 'blank' },
        { type: 'line', text: '  Some records require more than root access.', color: '#555' },
        { type: 'line', text: '  Some records require you to know what you\'re looking for.', color: '#555' },
        { type: 'blank' },
        { type: 'line', text: '  Dan mentioned a name. Find the paper.', color: '#c8a96e' },
        { type: 'blank' },
        { type: 'line', text: '  ✝', color: '#c8a96e' },
        { type: 'blank' },
      ]);
    }
    trackEvent('easter_egg', 'terminal', 'heaven_exe');
  };
  register(['heaven.exe', 'heaven exe', 'heaven'], heavenExeHandler);

  // ============================================
  // BOOK OF ENOCH — lore + game navigation
  // ============================================
  const enochHandler = () => {
    const parallaxUnlocked = sessionStorage.getItem('parallax_unlocked') === 'true';

    if (parallaxUnlocked) {
      addLines([
        { type: 'blank' },
        { type: 'line', text: '  ▓▓▓ THE BOOK OF ENOCH ▓▓▓', color: '#c8a96e' },
        { type: 'blank' },
        { type: 'line', text: '  "And Enoch walked with God: and he was not;', color: '#c8a96e' },
        { type: 'line', text: '   for God took him."', color: '#c8a96e' },
        { type: 'blank' },
        { type: 'line', text: '  The game is open. Navigate to GAMES.', color: '#00ff41' },
        { type: 'blank' },
        { type: 'line', text: '  Chazaqiel is waiting.', color: '#ff0040' },
        { type: 'line', text: '  The wires are still in his arms.', color: '#ff0040' },
        { type: 'blank' },
        { type: 'line', text: '  ✝', color: '#c8a96e' },
        { type: 'blank' },
      ]);
      navigate('/games');
    } else {
      addLines([
        { type: 'blank' },
        { type: 'line', text: '  ▓ THE BOOK OF ENOCH ▓', color: '#c8a96e' },
        { type: 'blank' },
        { type: 'line', text: '  An ancient text.', color: '#555' },
        { type: 'line', text: '  Excluded from the Bible.', color: '#555' },
        { type: 'line', text: '  Not excluded because it was wrong.', color: '#555' },
        { type: 'blank' },
        { type: 'line', text: '  It describes angels who came to Earth.', color: '#c8a96e' },
        { type: 'line', text: '  Angels who taught humans forbidden knowledge.', color: '#c8a96e' },
        { type: 'line', text: '  Angels who were punished for what they gave away.', color: '#c8a96e' },
        { type: 'blank' },
        { type: 'line', text: '  One was named Chazaqiel.', color: '#ff0040' },
        { type: 'blank' },
        { type: 'line', text: '  Read /var/mail/unread_dan.msg', color: '#c8a96e' },
        { type: 'line', text: '  He left a name. A researcher\'s name.', color: '#c8a96e' },
        { type: 'blank' },
        { type: 'line', text: '  ✝', color: '#c8a96e' },
        { type: 'blank' },
      ]);
    }
    trackEvent('easter_egg', 'terminal', 'book_of_enoch');
  };
  register(['book of enoch', 'enoch', 'the book of enoch'], enochHandler);

  // ============================================
  // MARCHETTI — circus lore
  // ============================================
  commandMap['marchetti'] = () => {
    addLines([
      { type: 'blank' },
      { type: 'line', text: '  ▓ MARCHETTI\'S PALACE OF WONDERS ▓', color: '#c8a96e' },
      { type: 'blank' },
      { type: 'line', text: '  Traveling circus. American Midwest.', color: '#cccccc' },
      { type: 'line', text: '  Active: approximately 1918–1922.', color: '#cccccc' },
      { type: 'blank' },
      { type: 'line', text: '  Performers:', color: '#555' },
      { type: 'line', text: '    — A sword-swallower', color: '#555' },
      { type: 'line', text: '    — A strongman', color: '#555' },
      { type: 'line', text: '    — A fortune teller with milk-white eyes', color: '#555' },
      { type: 'line', text: '    — Chazaqiel, the angel', color: '#c8a96e' },
      { type: 'blank' },
      { type: 'line', text: '  Owner: Ignazio Marchetti', color: '#cccccc' },
      { type: 'line', text: '  Claim: Chazaqiel was one of the Watchers', color: '#cccccc' },
      { type: 'line', text: '          from the Book of Enoch.', color: '#cccccc' },
      { type: 'blank' },
      { type: 'line', text: '  The circus disbanded after Chazaqiel vanished.', color: '#555' },
      { type: 'line', text: '  October 1922. North Dakota.', color: '#555' },
      { type: 'line', text: '  Nobody was ever charged.', color: '#555' },
      { type: 'blank' },
      { type: 'line', text: '  ✝', color: '#c8a96e' },
      { type: 'blank' },
    ]);
    trackEvent('easter_egg', 'terminal', 'marchetti');
  };

  // ============================================
  // WATCHERS — lore
  // ============================================
  const watchersHandler = () => {
    addLines([
      { type: 'blank' },
      { type: 'line', text: '  ▓ THE WATCHERS ▓', color: '#c8a96e' },
      { type: 'blank' },
      { type: 'line', text: '  From the Book of Enoch, Chapter 6:', color: '#555' },
      { type: 'blank' },
      { type: 'line', text: '  "And it came to pass when the children of men', color: '#c8a96e' },
      { type: 'line', text: '  had multiplied that in those days were born unto', color: '#c8a96e' },
      { type: 'line', text: '  them beautiful daughters. And the angels,', color: '#c8a96e' },
      { type: 'line', text: '  the children of the heaven, saw and lusted after them."', color: '#c8a96e' },
      { type: 'blank' },
      { type: 'line', text: '  200 Watchers descended.', color: '#cccccc' },
      { type: 'line', text: '  They brought forbidden knowledge.', color: '#cccccc' },
      { type: 'line', text: '  Herbology. Enchantments. The secrets of the stars.', color: '#cccccc' },
      { type: 'blank' },
      { type: 'line', text: '  One brought something the others did not.', color: '#ff0040' },
      { type: 'blank' },
      { type: 'line', text: '  Chazaqiel taught the signs of the clouds.', color: '#c8a96e' },
      { type: 'line', text: '  What that means has never been agreed upon.', color: '#555' },
      { type: 'blank' },
      { type: 'line', text: '  Threll had a theory.', color: '#555' },
      { type: 'blank' },
      { type: 'line', text: '  ✝', color: '#c8a96e' },
      { type: 'blank' },
    ]);
    trackEvent('easter_egg', 'terminal', 'watchers');
  };
  register(['watchers', 'the watchers'], watchersHandler);

  // ============================================
  // GIDEON — the Ontological Geneticist
  // (mentioned in Jose's journal)
  // ============================================
  commandMap['gideon'] = () => {
    const parallaxUnlocked = sessionStorage.getItem('parallax_unlocked') === 'true';

    if (parallaxUnlocked) {
      addLines([
        { type: 'blank' },
        { type: 'line', text: '  ▓ GIDEON — PARALLAX MEDICAL ▓', color: '#c8a96e' },
        { type: 'blank' },
        { type: 'line', text: '  Title: Ontological Geneticist', color: '#cccccc' },
        { type: 'line', text: '  Division: Genome Transcription, Sub-Level 3', color: '#cccccc' },
        { type: 'blank' },
        { type: 'line', text: '  Jose\'s journal, January 14, 1992:', color: '#555' },
        { type: 'line', text: '  "They took six vials of blood out of the angel', color: '#555' },
        { type: 'line', text: '  and then sent them upstairs to Gideon."', color: '#555' },
        { type: 'blank' },
        { type: 'line', text: '  Jose\'s journal, June 2, 1992:', color: '#555' },
        { type: 'line', text: '  "Gideon thinks Threll has lost his mind."', color: '#555' },
        { type: 'blank' },
        { type: 'line', text: '  Gideon is not listed in any public records.', color: '#ff0040' },
        { type: 'line', text: '  Gideon\'s current whereabouts: UNKNOWN', color: '#ff0040' },
        { type: 'blank' },
        { type: 'line', text: '  ✝', color: '#c8a96e' },
        { type: 'blank' },
      ]);
    } else {
      addLines([
        { type: 'blank' },
        { type: 'line', text: '  Gideon.', color: '#c8a96e' },
        { type: 'blank' },
        { type: 'line', text: '  A name without a surname.', color: '#555' },
        { type: 'line', text: '  An Ontological Geneticist.', color: '#555' },
        { type: 'line', text: '  A man who handled angel blood.', color: '#555' },
        { type: 'blank' },
        { type: 'line', text: '  Unlock the Parallax archive to learn more.', color: '#c8a96e' },
        { type: 'blank' },
        { type: 'line', text: '  ✝', color: '#c8a96e' },
        { type: 'blank' },
      ]);
    }
    trackEvent('easter_egg', 'terminal', 'gideon');
  };

}